import React from 'react';

export const Spinner = () => {
	return (
		<div style={{
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: 'rgba(0, 0, 0, 0.6)',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			zIndex: 9999,
			cursor: 'not-allowed'
		}}>
			<div style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: '20px'
			}}>
				<div style={{
					width: '50px',
					height: '50px',
					border: '5px solid rgba(255, 255, 255, 0.3)',
					borderTop: '5px solid #667eea',
					borderRadius: '50%',
					animation: 'spin 1s linear infinite'
				}} />
				<p style={{
					color: 'white',
					fontSize: '16px',
					fontWeight: '500',
					margin: 0
				}}>Procesando...</p>
			</div>
			<style>
				{`
					@keyframes spin {
						0% { transform: rotate(0deg); }
						100% { transform: rotate(360deg); }
					}
				`}
			</style>
		</div>
	);
}